//
//
// This file contains pieces from
// prerender-private-cache/middleware/ignore-urls.js
//
//

const NEVER_MATCH = { test: () => false, responseFn: () => {} };

// Q: Why not a package?
// A: All glob/wildcard packages are made for file matching
//    So for example:
//    duck*goose won't match for https://httpbin.org/anything/duckasdgoose only **/duck*goose would
const wildcardToRegex = (rule) => {
  const escapeRegex = (u) => u.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'); // eslint-disable-line
  return new RegExp(`^${rule.split('*').map(escapeRegex).join('.*')}$`);
};

const CASE_INSENSITIVE_PREFIX = '(?i)';

// JS regex has no inline-flag syntax (`(?i)` throws). Treat a leading `(?i)` as
// an opt-in case-insensitive marker: strip it and pass the `i` flag explicitly.
const compileRegex = (pattern) => {
  if (pattern.startsWith(CASE_INSENSITIVE_PREFIX)) {
    return new RegExp(pattern.slice(CASE_INSENSITIVE_PREFIX.length), 'i');
  }
  return new RegExp(pattern);
};

const compileContains = (pattern) => {
  if (pattern.startsWith(CASE_INSENSITIVE_PREFIX)) {
    const needle = pattern.slice(CASE_INSENSITIVE_PREFIX.length).toLowerCase();
    return (url) => url.toLowerCase().includes(needle);
  }
  return (url) => url.includes(pattern);
};

const validateResponseConfig = (responseConfig) => !!responseConfig.status;

// eslint-disable-next-line import/prefer-default-export
export const ruleConfigIntoRule = (ruleConfig) => {
  const { type, pattern, response } = ruleConfig;
  if (!validateResponseConfig(response)) return NEVER_MATCH;

  // On match this will send the response to the crawler
  const responseFn = (res) => {
    if (response.status) res.status(response.status);
    if (response.headers) res.set(response.headers);
    return res.send(response.data);
  };

  // Case-sensitivity mirrors the backend request-time matcher (private-cache / recache-server):
  // all types are case-sensitive by default; a leading `(?i)` opts a REGEX or CONTAINS
  // pattern into case-insensitive matching. (PRE-2827)
  switch (type) {
    case 'REGEX': {
      const regex = compileRegex(pattern);
      return { test: (url) => regex.test(url), responseFn };
    }
    case 'CONTAINS': {
      const contains = compileContains(pattern);
      return { test: (url) => contains(url), responseFn };
    }
    case 'WILDCARD': {
      const regex = wildcardToRegex(pattern);
      return { test: (url) => regex.test(url), responseFn };
    }

    default: return NEVER_MATCH;
  }
};
